var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"waiting"},[_c('div',{staticStyle:{"align-self":"center"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":50,"width":2,"color":"#4caf50"}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }